export default {
      id: "dropdown-arrow-alt-usage",
      viewBox: "0 0 10 6",
      url: __webpack_public_path__ + "sprite-46b249.svg#dropdown-arrow-alt-usage",
      toString: function () {
        return this.url;
      }
    }